import { useEffect, useState } from 'react'
import { RuuviTag } from '../types'
import { getRuuviTag } from '../services/ruuviTagService'
import { AxiosRequestConfig } from 'axios'

interface RuuviTagLoader {
  ruuviTag: RuuviTag | null
  loading: boolean
  error: unknown | null
}

export function useRuuviTagLoader(id: string): RuuviTagLoader {
  /**
   * The RuuviTag state.
   */
  const [ruuviTag, setRuuviTag] = useState<RuuviTag | null>(null)

  /**
   * The loading state.
   */
  const [loading, setLoading] = useState<boolean>(true)

  /**
   * The error state.
   */
  const [error, setError] = useState<unknown | null>(null)

  /**
   * Load the RuuviTag by ID.
   */
  async function loadRuuviTag(id: string, config: AxiosRequestConfig = {}): Promise<void> {
    try {
      setLoading(true)
      setError(null)
      setRuuviTag(await getRuuviTag(id, config))
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  /**
   * Load the RuuviTag when the id changes.
   */
  useEffect(() => {
    const controller = new AbortController()
    loadRuuviTag(id, { signal: controller.signal })
    return () => controller.abort()
  }, [id])

  return {
    ruuviTag,
    loading,
    error
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-unused-vars
interface RuuviTagAlertTemmplateLoader {}

export function useRuuviTagAlertTemplateLoader() {}
